// extracted by mini-css-extract-plugin
export default {"card":"custody_card__XMi1Q","tableCard":"custody_tableCard__-uPVP","row":"custody_row__COsjl"};